import { Box, Typography } from '@mui/material';
import { COPY } from '../copy';
import { resolveCta } from '../cta';
import { useSurface } from '../layouts/block-surface-context';
import { useLayoutStyles } from '../layouts/layout-context';
import type { BlockRenderProps } from '../layouts/types';
import { AccentText } from '../primitives/accent-text';
import { AnchorButton, CtaButton } from '../primitives/cta-button';
import { Wrap } from '../primitives/wrap';

export const ClosingCtaBlock = ({
  block,
  settings,
  plansBlockId,
  onCta,
  pendingCta,
}: BlockRenderProps) => {
  const s = useLayoutStyles('closingCta');
  const secondaryVariant = useSurface('dark') === 'dark' ? 'dark' : 'ghost';
  if (block.type !== 'closingCta') return null;

  const cta = resolveCta({
    settings,
    onCta,
    pendingCta,
    blockId: block.id,
    label: block.buttonLabel,
  });

  return (
    <Box sx={s.section}>
      <Wrap>
        <Typography component="h2" sx={s.headline}>
          <AccentText text={block.headline} surface="dark" />
        </Typography>
        {block.subtext ? (
          <Typography component="p" sx={s.subtext}>
            <AccentText text={block.subtext} surface="dark" />
          </Typography>
        ) : null}
        <Box sx={s.ctaRow}>
          <CtaButton target={cta} variant="brand" withArrow />
          {plansBlockId ? (
            <AnchorButton
              href={`#${plansBlockId}`}
              label={COPY.viewPlans}
              variant={secondaryVariant}
            />
          ) : null}
        </Box>
      </Wrap>
    </Box>
  );
};
